/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-extra-boolean-cast */
/*

MfcACRText
 

	example:

	var acrText = new MfcACRText();

	// simple replace bad word chars with *
	acrText.process( hMap['username'],{ match_partial: true, replacement_char: 'x' } );

	// replace only vowels of bad word with *
	acrText.process( hMap['username'],{ match_partial: true, replace_vowels: true, replacement_char: 'x' } );

	// default handling, replace bad words with euphemisms where possible
	username = acrText.process( chatString );


*/

function MfcACRText(config) {
    config = config || {}

    this._patterns = {}

    // modify from main library due to SSR
    var debug = 0
    if (typeof window !== 'undefined') {
        debug = location?.search.match(/acrtext/) ? 1 : 0
    }

    this._getPattern = function () {
        if (Object.keys(this._patterns).length !== 0) {
            return this._patterns
        }

        for (var category in this.word_filter) {
            const wordPattern = Object.keys(this.word_filter[category] || {})

            if (!wordPattern.length) {
                this._patterns[category] = null
                return null
            }

            var pattern
            if (category == 'banned_string' || config.match_partial) {
                pattern = new RegExp('(' + wordPattern.join('|') + ')', 'giu')
            } else {
                pattern = new RegExp(
                    '\\b(' + wordPattern.join('|') + ')(s|ing)*\\b',
                    'giu',
                )
            }

            if (debug) {
                console.log(pattern)
            }

            this._patterns[category] = pattern
        }

        return this._patterns
    }

    this.banned_words = function (string, opts) {
        opts = opts || {}
        opts.return_boolean = 1
        return this.process(string, opts)
    }

    this.process = function (string, opts) {
        if (typeof string != 'string') {
            return string
        }

        opts = opts || {}
        var wordsFound = false

        if (!string) {
            if (opts.return_boolean) return false
            return string
        }

        string = string.replace(/(\d+)(\w+)/g, '$1 $2')

        const patterns = this._getPattern()

        var replaced = string
        for (var category in patterns) {
            var pattern = patterns[category]
            var self = this

            replaced = String(replaced).replace(pattern, function (match) {
                wordsFound = true

                match = match.toLowerCase()

                if (!!opts.replacement_char) {
                    if (opts.replace_vowels)
                        return match.replace(/[aeiouy]/g, opts.replacement_char)
                    else return opts.replacement_char.repeat(match.length)
                } else {
                    var replacement = null

                    if (self.word_filter && self.word_filter[category]) {
                        if (
                            self.word_filter[category][match] &&
                            typeof self.word_filter[category][match].r !==
                                'undefined'
                        ) {
                            replacement = self.word_filter[category][match].r
                        }
                    }

                    if (replacement != null) {
                        1
                    } else if (category == 'banned_string') {
                        replacement = ''
                    } else if (category == 'verbs' && match.match(/ing$/)) {
                        replacement = 'doing'
                    } else if (category == 'nouns') {
                        replacement = '***'
                    } else if (category == 'verbs') {
                        replacement = '***'
                    } else if (category == 'adjectives') {
                        replacement = 'nice'
                    } else {
                        replacement = ''
                    }

                    if (debug) {
                        console.log(match, ' => ', replacement)
                    }
                    self.reportWords[match + ' ' + replacement] = self
                        .reportWords[match + ' ' + replacement]
                        ? self.reportWords[match + ' ' + replacement] + 1
                        : 1

                    return replacement
                }
            })
        }

        if (opts.return_boolean) {
            return wordsFound
        }

        if (wordsFound) {
            replaced = replaced.replace(/\s+/g, ' ')
        }

        if (debug && wordsFound) {
            console.log(string)
            console.log(replaced)
            console.log('----------------------')
        }
        return replaced
    }

    this.reportWords = {}
    this.report = function () {
        const sorted = Object.entries(this.reportWords).sort(
            ([, a], [, b]) => b - a,
        ) // DESC by value

        sorted.forEach(([word, count]) => {
            console.log(word, count)
        })
    }

    this.word_filter = {
        phrases: {
            'in my': { r: 'in the' },
            'in your': { r: 'in the' },
        },
        adjectives: {
            big: { r: 'sizeable' },
            'big\\w+': {},
            creamy: {},
            deep: { r: '' },
            drunk: {},
            erotic: {},
            fat: { r: 'large' },
            gay: {},
            genital: {},
            hard: { r: 'tough' },
            'horn[^]+': {},
            horny: { r: 'excited' },
            hot: {},
            lewd: {},
            little: { r: 'small' },
            naked: { r: 'unclothed' },
            naughty: {},
            nude: { r: 'undressed' },
            oral: {},
            private: { r: 'exclusive' },
            sexy: {},
            shaved: {},
            slutty: {},
            topless: { r: 'undressed' },
            wet: {},
            young: {},
        },
        verbs: {
            anal: {},
            bang: {},
            beat: {},
            blast: {},
            blow: {},
            blowjob: { r: 'job' },
            bone: {},
            choke: {},
            damn: { r: 'dang' },
            dismember: {},
            dominate: {},
            drill: {},
            ejacul: {},
            ejaculate: {},
            finger: { r: '' },
            'finger\\w+': {},
            flash: { r: 'show' },
            flashtits: { r: 'show' },
            footjob: { r: 'job' },
            grope: {},
            handjob: { r: 'job' },
            homewreck: {},
            homewrecking: {},
            hook: {},
            hump: {},
            impale: {},
            jacking: {},
            jackoff: {},
            jerk: {},
            kick: {},
            kill: {},
            lick: {},
            masturb: {},
            masturbat: {},
            masturbate: {},
            masturbation: {},
            mutilate: {},
            piss: {},
            plow: {},
            pound: {},
            pump: {},
            punch: {},
            rail: {},
            screw: {},
            shoot: {},
            slam: {},
            slash: {},
            smack: {},
            smash: {},
            sodom: {},
            spank: { r: 'paddle' },
            spear: {},
            spread: {},
            squirt: { r: 'go' },
            stab: {},
            strangle: {},
            strap: {},
            strike: {},
            strip: { r: 'undress' },
            striptease: { r: 'undress' },
            strok: {},
            suck: {},
            sucktoy: {},
            swallow: {},
            tug: {},
            undress: {},
            wank: {},
            whack: {},
            wreck: {},
            yank: {},
        },
        nouns: {
            acid: {},
            alcohol: {},
            analshow: { r: 'performance' },
            anatomy: {},
            anus: {},
            ass: { r: 'back' },
            asshole: { r: 'back' },
            baby: { r: 'cutie' },
            ball: {},
            bar: {},
            bb: { r: 'cutie' },
            bbw: { r: 'beautiful' },
            bby: { r: 'cutie' },
            bdsm: { r: 'dom' },
            beaner: {},
            beaver: {},
            beer: { r: 'beverage' },
            benzo: {},
            bigboob: { r: 'mellon' },
            bigboobs: { r: 'mellons' },
            bigtit: { r: 'mellon' },
            bigtits: { r: 'mellons' },
            bone: {},
            boner: {},
            boob: { r: 'mellon' },
            boobies: { r: 'mellons' },
            boobs: { r: 'mellons' },
            boot: {},
            booty: { r: 'back' },
            boy: {},
            breast: { r: 'top' },
            breasts: { r: 'tops' },
            bukkake: {},
            bulldyke: {},
            bung: {},
            bust: {},
            butt: { r: 'behind' },
            buttplug: { r: 'device' },
            cannabis: {},
            cheak: {},
            child: {},
            chute: {},
            clit: {},
            coke: {},
            condom: {},
            copulation: {},
            crack: {},
            crank: {},
            cream: {},
            cum: {},
            cumshow: { r: 'performance' },
            cunni: {},
            cupcake: {},
            dad: {},
            daddy: {},
            daughter: {},
            deepthroat: {},
            dildo: { r: 'device' },
            dmt: {},
            dog: { r: 'pet' },
            dogg: {},
            dogs: { r: 'pets' },
            dope: {},
            dp: {},
            drug: {},
            ecstasy: {},
            equipment: {},
            erection: {},
            face: { r: '' },
            fag: {},
            fent: {},
            fetish: {},
            fist: {},
            flower: {},
            footjob: {},
            foursome: {},
            ganja: {},
            genitalia: {},
            ghb: {},
            gun: {},
            guro: {},
            hammer: {},
            handjob: {},
            hentai: {},
            heroin: {},
            hole: {},
            homo: {},
            hook: {},
            hooker: {},
            incest: {},
            intercourse: {},
            jizz: {},
            joystick: {},
            jugg: {},
            kid: {},
            kush: {},
            lapdance: {},
            leg: {},
            lesbian: {},
            lolita: {},
            lovense: { r: 'device' },
            lush: { r: 'device' },
            manhood: {},
            mescaline: {},
            meth: {},
            milf: {},
            mom: {},
            mommy: {},
            mother: {},
            muff: {},
            murder: {},
            neonazi: {},
            nimf: {},
            nimph: {},
            niple: {},
            nipple: {},
            nut: {},
            nympho: {},
            onlyfans: { r: 'OF' },
            opiate: {},
            opium: {},
            orgasm: { r: 'finish' },
            oxy: {},
            package: {},
            panties: { r: 'bottoms' },
            panty: { r: 'bottom' },
            pecker: {},
            pedo: {},
            peep: {},
            peg: {},
            penetrat: {},
            penis: {},
            perv: {},
            peyote: {},
            phallus: {},
            piss: {},
            pole: {},
            poon: {},
            poop: {},
            porn: {},
            pube: {},
            puffynipples: {},
            punany: {},
            pussy: { r: 'pie' },
            queaf: {},
            queef: {},
            quim: {},
            rape: {},
            rapist: {},
            rectum: {},
            reefer: {},
            saggyboobs: { r: 'mellons' },
            scat: {},
            schlong: {},
            scrotum: {},
            semen: {},
            sex: {},
            sexmachine: {},
            shaft: {},
            shemale: {},
            shroom: {},
            skag: {},
            skunk: {},
            skype: { r: 'exclusive' },
            slut: { r: 'girl' },
            smut: {},
            snake: {},
            snatch: {},
            sperm: {},
            spic: {},
            spice: {},
            splooge: {},
            spooge: {},
            spunk: {},
            taint: {},
            teen: { r: 'attractive' },
            testicle: {},
            thigh: {},
            threesome: {},
            throat: {},
            throatgoat: {},
            tit: { r: 'bit' },
            tits: { r: 'bits' },
            titties: { r: 'bitties' },
            titty: {},
            toilet: { r: 'bowl' },
            tongue: {},
            tool: {},
            torture: {},
            toy: { r: 'device' },
            tran: {},
            tush: {},
            twat: {},
            twink: {},
            vagina: {},
            viagra: {},
            vibration: { r: 'movement' },
            vibrations: { r: 'movements' },
            vibrator: { r: 'device' },
            video: { r: 'media' },
            videos: { r: 'media' },
            vulva: {},
            wand: {},
            weed: {},
            whisky: {},
            whore: {},
        },
        banned_string: {
            bitch: {},
            cock: {},
            cunt: {},
            cum: {},
            dick: {},
            fuck: {},
            nigg: {},
            puss: {},
            shit: {},
        },
    }
}

export default MfcACRText
